import React, { Suspense, useEffect, useState } from "react";
import CommonLayout from "../../../../../layouts/commonLayout/CommonLayout";
import { NavLink, Outlet, useParams } from "react-router-dom";
import baseUrl from "../../../../../api/baseUrl";
import PatientModal from "./PatientModal";
import PersonIcon from "@mui/icons-material/Person";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import MedicationIcon from "@mui/icons-material/Medication";
import HistoryIcon from "@mui/icons-material/History";
import EventNoteIcon from "@mui/icons-material/EventNote";
import VisibilityIcon from "@mui/icons-material/Visibility";

function AddTreatment() {
  const [patientData, setpatientData] = useState({
    userName: "",
    regNo: "",
    image: "",
    phonnum: "",
  });
  const [data, setdata] = useState();
  const [close, setclose] = useState(false);
  const { ID } = useParams();

  useEffect(() => {
    baseUrl
      .get("treatment/find-treatment", {
        headers: { treatmentid: ID },
      })
      .then((response) => {
        setdata(response.data.data.patientId);
        setpatientData({
          userName: response.data.data.patientId.fullName,
          regNo: response.data.data.patientId.regNo,
          phonnum: response.data.data.patientId.mobileNo,
          image: response.data.data.patientId.image,
        });
      })
      .catch((error) => console.log(error));
  }, [ID]);

  const handleCloseModal = () => setclose(false);
  const handleViewPatientClick = () => setclose(true);

  const navItems = [
    { path: `diagnose/${ID}`, label: "DIAGNOSE", icon: LocalHospitalIcon },
    { path: `treatment-table/${ID}`, label: "TREATMENT", icon: MedicationIcon },
    { path: `drugs/${ID}`, label: "DRUGS", icon: MedicationIcon },
    { path: `past-treatment/${ID}`, label: "PAST TREATMENT", icon: HistoryIcon },
    { path: `treatment-planned/${ID}`, label: "PLANNED", icon: EventNoteIcon },
  ];

  return (
    <CommonLayout>
      <div className="mb-4">
        {/* Patient Profile Card */}
        <div className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-4 mb-4">
          <div className="flex flex-col md:flex-row md:items-center gap-4">
            {/* Avatar */}
            <div className="flex-shrink-0">
              {patientData?.image ? (
                <img
                  src={patientData.image}
                  alt={patientData.userName}
                  className="w-14 h-14 rounded-lg object-cover border-2 border-indigo-100"
                />
              ) : (
                <div className="w-14 h-14 rounded-lg bg-gradient-to-br from-primary to-primaryLight flex items-center justify-center">
                  <PersonIcon className="text-white" sx={{ fontSize: 28 }} />
                </div>
              )}
            </div>

            {/* Patient Info */}
            <div className="flex-1">
              <h2 className="text-base font-bold text-slate-800">{patientData?.userName || "Patient Name"}</h2>
              <div className="flex flex-wrap gap-3 mt-1.5">
                <span className="px-2.5 py-0.5 bg-indigo-100 text-indigo-700 rounded-md text-xs font-medium">
                  Reg No: {patientData?.regNo}
                </span>
                <span className="text-slate-600 text-xs">{patientData?.phonnum}</span>
              </div>
            </div>

            {/* View Details Button */}
            <button
              onClick={handleViewPatientClick}
              className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium text-xs hover:shadow-lg hover:shadow-primary/20 transition-all"
            >
              <VisibilityIcon sx={{ fontSize: 16 }} />
              Patient Details
            </button>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="bg-white rounded-lg shadow-sm border border-slate-100 p-1 flex flex-wrap gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-medium transition-all ${
                  isActive
                    ? "bg-gradient-to-r from-primary to-primaryLight text-white shadow-lg shadow-primary/20"
                    : "text-slate-600 hover:bg-slate-100"
                }`
              }
            >
              <item.icon sx={{ fontSize: 14 }} />
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Content Outlet */}
      <Suspense
        fallback={
          <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="w-12 h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        }
      >
        <Outlet />
      </Suspense>

      {close && <PatientModal patient={data} onClose={handleCloseModal} />}
    </CommonLayout>
  );
}

export default AddTreatment;
